import { render, staticRenderFns } from "./startconfig.vue?vue&type=template&id=5fa5250b&scoped=true&"
import script from "./startconfig.vue?vue&type=script&lang=ts&"
export * from "./startconfig.vue?vue&type=script&lang=ts&"
import style0 from "./startconfig.vue?vue&type=style&index=0&id=5fa5250b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa5250b",
  null
  
)

export default component.exports